import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Dashboard from "./Page/Dashboard/Dashboard";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Setting from "./Page/setting/Setting";
import Login from "./Page/Authentication/Login";
import ChangePasssword from "./Page/Authentication/ChangePasssword";
import Forgotpassword from "./Page/Authentication/Forgotpassword";
import ResetPassword from "./Page/Authentication/ResetPassword";
import Pagewisebanner from "./Page/MasterTable/PageBanner/PageBanner";
import AddPagewisebanner from "./Page/MasterTable/PageBanner/AddPageBanner";
import SocialMedia from "./Page/SocialMedia";
import AddEmailtemplate from "./Page/setting/AddEmailtemplate";
import EmailTemplate from "./Page/setting/EmailTemplate";
import Sitemap from "./Page/Sitemap";
import Currency from "./Page/MasterTable/Currency/Currency";
import Catalogue from "./Page/Product/Catalogue/Catalogue";
import Products from "./Page/Product/SingleProduct/Product";
import AddProduct from "./Page/Product/SingleProduct/AddProduct";
import CataloguesProduct from "./Page/Product/Catalogue/CatalogueProduct";
import StichingOption from "./Page/Stitching/StitchingOption";
import Testimonial from "./Page/Testimonial";
import Profile from "./Page/Profile";
import HomeBanner from "./Page/MasterTable/HomeBanner/HomeBanner";
// import AddHomeBanner from "./Page/MasterTable/AddHomeBanner";
import EmailConfiguration from "./Page/setting/EmailConfiguration";
import "./App.css";
import Category from "./Page/Product/Category/Category";
import AddCategory from "./Page/Product/Category/AddCategory";
import Subcategory from "./Page/Product/Category/SubCategory";
import Size from "./Page/MasterTable/Size";
import StitchingMeasurement from "./Page/Stitching/Measurement";
import StitchingPage from "./Page/Stitching/StitchingPage";
import Newsletter from "./Page/NewsLetter";
import Payment from "./Page/setting/Payment";
import ShippingZone from "./Page/shipping/ShippingZone";
import PageContent from "./Page/MasterTable/PageContent/PageContent";
import Layout from "./layout";
import Cms from "./Page/MasterTable/CMS/Cms";
import AddCms from "./Page/MasterTable/CMS/AddCms";
import DraftCatalogue from "./Page/Product/Catalogue/DraftCatalogue";
import Attributes from "./Page/MasterTable/Attributes";
import AttributeValue from "./Page/MasterTable/Attributes/AttributeValue";
import AddGroupForm from "./Page/Stitching/AddGroupForm";
import UserOrder from "./Page/User/UserOrder";
import Brand from "./Page/Product/Brand/Brand";
import Role from "./Page/RolePermission/Role";
import Permission from "./Page/RolePermission/Permission/permission";
import Handler from "./Page/RolePermission/Handler/Handler";
import AddCatalogue from "./Page/Product/Catalogue/AddCatalogue";
import AddCatalogueProduct from "./Page/Product/Catalogue/AddCatalogueProduct";
import AddPopups from "./Page/Popups/AddPopups";
import Popups from "./Page/Popups/Popups";
import CataloueProductUpdate from "./Page/Product/Catalogue/CataloueProductUpdate";
import AddPageContent from "./Page/MasterTable/PageContent/AddPageContent";
import Theme from "./Page/Theme/theme";
import AddTheme from "./Page/Theme/themeAdd";
import Invoice from "./Page/User/Documents/Invoice";
// import Dispatch from "./Page/dispatch/dispatch";
import OrderDetailPage from "./Page/User/orderDetail/OrderDetailPage";
import AddMenu from "./Page/MasterTable/Menu/AddMenu";
import Menu from "./Page/MasterTable/Menu/Menu";
import SubMenu from "./Page/MasterTable/Menu/SubMenu";
import AddSubMenu from "./Page/MasterTable/Menu/AddSubMenu";
import UploadFile from "./Page/Product/Media/UploadFile";
import UploadSheet from "./Page/Product/Media/ExcelUploader";
import Customers from "./Page/User/Customer";
import CustomerDetail from "./Page/User/CustomerDetail";
import ShippingPartner from "./Page/shipping/Partner/ShippingPartner";
import MenuImage from "./Page/MasterTable/Menu/MenuImage";
import AddHomeBanner from "./Page/MasterTable/HomeBanner/AddHomeBanner";
import Transaction from "./Page/Transaction/Transaction";
import MegaMenu from "./Page/MasterTable/Menu/MegaMenu";
import Collection from "./Page/HomePage/collection/Collection";
import AddCollection from "./Page/HomePage/collection/AddCollection";
import ProductCollection from "./Page/HomePage/collection/ProductCollection";
import CatalogueCollection from "./Page/HomePage/collection/CatalogueCollection";
import HomeSection from "./Page/HomePage/HomeSection/HomeSection";
import AddHomeSection from "./Page/HomePage/HomeSection/AddHomeSection";
import HomeItem from "./Page/HomePage/HomeSection/HomeItem";
import ProductsInquiry from "./Page/ProductsInquiry";
import ContactsInquiry from "./Page/ContactsInquiry";
import AddCurrency from "./Page/MasterTable/Currency/AddCurrency";
import AddTestimonial from "./Page/AddTestimonial";
import AddPaymentMethod from "./Page/setting/AddPaymentMethod";
import ContactInquiryDetail from "./Page/ContactInquiryDetail";
import ProductInquiryDetail from "./Page/ProductInquiryDetail";
import PagePermission from "./Page/RolePermission/PagePermission/PagePermission";
import AddHandler from "./Page/RolePermission/Handler/AddHandler";
import PermissionProvider from "./Auth/PermissionProvider";
import ProtectedRoute from "./Auth/ProtectedRoute";
import Search from "./Page/Product/Search/Search";


function RequireAuth({ children }) {
  let accessToken = localStorage.getItem("token");
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  let accessToken = localStorage.getItem("token");
  return (
    <PermissionProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={accessToken ? <Navigate to="/dashboard" replace /> : <Login />}
          />
          <Route
            path="/forgot-password"
            element={
              accessToken ? <Navigate to="/dashboard" replace /> : <Forgotpassword />
            }
          />
          <Route
            path="/reset-password"
            element={
              accessToken ? <Navigate to="/dashboard" replace /> : <ResetPassword />
            }
          />

          <Route
            path="*"
            element={
              <RequireAuth>
                <Layout>
                  <Routes>
                    <Route
                      path="/dashboard"
                      element={<ProtectedRoute pageKey="Dashboard" > <Dashboard /></ProtectedRoute>} />


                    <Route
                      path="/currency"
                      element={<ProtectedRoute pageKey="Currency" > <Currency /></ProtectedRoute>} />

                    <Route
                      path="/add-currency"
                      element={<ProtectedRoute pageKey="Currency" > <AddCurrency /></ProtectedRoute>} />
                    <Route
                      path="/sizes"
                      element={<ProtectedRoute pageKey="Sizes" > <Size /></ProtectedRoute>} />
                    <Route
                      path="/page-content"
                      element={<ProtectedRoute pageKey="Page Content" ><PageContent /></ProtectedRoute>} />
                    <Route
                      path="/add-page-content"
                      element={<ProtectedRoute pageKey="Page Content" > <AddPageContent /></ProtectedRoute>} />

                    <Route
                      path="/menu"
                      element={<ProtectedRoute pageKey="Menu" ><Menu /></ProtectedRoute>} />

                    <Route
                      path="/add-menu"
                      element={<ProtectedRoute pageKey="Menu" > <AddMenu /></ProtectedRoute>}
                    />
                    <Route
                      path="/add-submenu"
                      element={<ProtectedRoute pageKey="Sub Menu" > <AddSubMenu /></ProtectedRoute>}
                    />
                    <Route
                      path="/menu-image"
                      element={<ProtectedRoute pageKey="Sub Menu" > <MenuImage /></ProtectedRoute>}
                    />
                    <Route
                      path="/submenu"
                      element={<ProtectedRoute pageKey="Sub Menu" ><SubMenu /></ProtectedRoute>}
                    />

                    <Route
                      path="/mega-menu"
                      element={<ProtectedRoute pageKey="Menu" ><MegaMenu /></ProtectedRoute>}
                    />

                    <Route
                      path="/home-banner"
                      element={<ProtectedRoute pageKey="Home Banners" ><HomeBanner /></ProtectedRoute>}
                    />
                    <Route
                      path="/add-home-banner"
                      element={<ProtectedRoute pageKey="Home Banners" ><AddHomeBanner /></ProtectedRoute>}
                    />

                    <Route
                      path="/page-banner"
                      element={<ProtectedRoute pageKey="Page banners" > <Pagewisebanner /> </ProtectedRoute>}
                    />

                    <Route
                      path="/add-page-banner"
                      element={<ProtectedRoute pageKey="Page banners" ><AddPagewisebanner /> </ProtectedRoute>}
                    />

                    <Route
                      path="/cms"
                      element={<ProtectedRoute pageKey="CMS" > <Cms /></ProtectedRoute>}
                    />

                    <Route
                      path="/add-cms"
                      element={
                        <ProtectedRoute pageKey="CMS" > <AddCms /></ProtectedRoute>}
                    />

                    <Route
                      path="/attributes"
                      element={<ProtectedRoute pageKey="Attributes" ><Attributes /></ProtectedRoute>}
                    />

                    <Route
                      path="/attribute-value/:id"
                      element={
                        <ProtectedRoute pageKey="Attribute Value" >
                          <AttributeValue />
                        </ProtectedRoute>
                      }
                    />
                    {/* MASTER PAGE ROUTE END*/}


                    {/* PRODUCTS ROUTE */}
                    <Route
                      path="/category"
                      element={<ProtectedRoute pageKey="Category" ><Category /></ProtectedRoute>}
                    />

                    <Route
                      path="/add-category"
                      element={<ProtectedRoute pageKey="Category" > <AddCategory /></ProtectedRoute>}
                    />

                    <Route
                      path="/sub-category"
                      element={<ProtectedRoute pageKey="Sub Category" ><Subcategory /></ProtectedRoute>}
                    />

                    <Route
                      path="/products/:id"
                      element={<ProtectedRoute pageKey="Products" ><Products /></ProtectedRoute>}
                    />

                    <Route
                      path="/add-products/:id"
                      element={<ProtectedRoute pageKey="Products" > <AddProduct /> </ProtectedRoute>}
                    />

                    <Route
                      path="/catalogue/:id"
                      element={<ProtectedRoute pageKey="Catalogue" ><Catalogue /></ProtectedRoute>}
                    />

                    <Route
                      path="/catalogue-products/:id"
                      element={<ProtectedRoute pageKey="Catalogue" > <CataloguesProduct /></ProtectedRoute>}
                    />

                    <Route
                      path="/catalogue-add/:id"
                      element={<ProtectedRoute pageKey="Catalogue" > <AddCatalogue /> </ProtectedRoute>}
                    />


                    <Route
                      path="/catalogue-product/update"
                      element={<ProtectedRoute pageKey="Catalogue" > <CataloueProductUpdate /></ProtectedRoute>}
                    />


                    <Route
                      path="/add-catalogue-product"
                      element={<ProtectedRoute pageKey="Catalogue" ><AddCatalogueProduct /></ProtectedRoute>}
                    />


                    <Route
                      path="/darft-catalogue"
                      element={<ProtectedRoute pageKey="Draft Catalogue" > <DraftCatalogue /></ProtectedRoute>}
                    />

                    <Route
                      path="/brands"
                      element={<ProtectedRoute pageKey="brands" ><Brand /></ProtectedRoute>}
                    />
                    {/* PRODUCTS ROUTE  END*/}


                    {/* STITCHING ROUTE */}

                    <Route
                      path="/stitching-group"
                      element={<ProtectedRoute pageKey="Stitching Group" ><AddGroupForm /></ProtectedRoute>}
                    />

                    <Route
                      path="/stitching"
                      element={<ProtectedRoute pageKey="Stitching Group" > <StitchingPage /></ProtectedRoute>}
                    />

                    <Route
                      path="/stitching-option/:id"
                      element={<ProtectedRoute pageKey="Stitching Option" ><StichingOption /> </ProtectedRoute>}
                    />
                    <Route
                      path="/stitching-measurement/:id"
                      element={<ProtectedRoute pageKey="Stitching Measurements" ><StitchingMeasurement /> </ProtectedRoute>}
                    />
                    {/* STITCHING ROUTE END*/}

                    {/* SHIPPING ZONE AND PARTNER ROUTE */}

                    <Route
                      path="/shipping-partner"
                      element={<ProtectedRoute pageKey="Shipping Partners" > <ShippingPartner /></ProtectedRoute>}
                    />

                    <Route
                      path="/shipping-zone"
                      element={<ProtectedRoute pageKey="Shipping Zone" ><ShippingZone /></ProtectedRoute>}
                    />

                    {/* SHIPPING ZONE AND PARTNER ROUTE END*/}



                    {/* ORDER ,CUSTOMER,TRANSACTION */}
                    <Route
                      path="/transaction"
                      element={<ProtectedRoute pageKey="Transaction" ><Transaction /></ProtectedRoute>}
                    />

                    <Route
                      path="/customers"
                      element={<ProtectedRoute pageKey="Customers" ><Customers /></ProtectedRoute>}
                    />

                    <Route
                      path="/customers-detail/:id"
                      element={<ProtectedRoute pageKey="Customers" ><CustomerDetail /></ProtectedRoute>} />


                    <Route
                      path="/orders"
                      element={<ProtectedRoute pageKey="Orders" ><UserOrder /></ProtectedRoute>}
                    />

                    <Route
                      path="/order/detail/:id"
                      element={<ProtectedRoute pageKey="Orders" ><OrderDetailPage /></ProtectedRoute>}
                    />

                    <Route
                      path="/customers/order/:id"
                      element={<ProtectedRoute pageKey="Orders" ><UserOrder /></ProtectedRoute>}
                    />
                    {/* END */}


                    {/* UPLOAD */}
                    <Route
                      path="/upload-sheet"
                      element={<ProtectedRoute pageKey="Upload Sheet" ><UploadSheet /></ProtectedRoute>}
                    />

                    <Route
                      path="/upload-images"
                      element={<ProtectedRoute pageKey="Upload Image" ><UploadFile /></ProtectedRoute>
                      }
                    />
                    <Route
                      path="/contact-inquiry-detail"
                      element={<ProtectedRoute pageKey="Contacts Inquiry" ><ContactInquiryDetail /></ProtectedRoute>} />

                    <Route
                      path="/product-inquiry-detail"
                      element={<ProtectedRoute pageKey="Products Inquiry" ><ProductInquiryDetail /></ProtectedRoute>} />
                    {/* END */}

                    <Route
                      path="/contact"
                      element={<ProtectedRoute pageKey="Contacts Inquiry" ><ContactsInquiry /></ProtectedRoute>}
                    />
                    <Route
                      path="/product-inquiry"
                      element={<ProtectedRoute pageKey="Products Inquiry" ><ProductsInquiry /></ProtectedRoute>}
                    />


                    <Route
                      path="/role"
                      element={<ProtectedRoute pageKey="Roles" ><Role /> </ProtectedRoute>
                      }
                    />

                     <Route
                      path="/search"
                      element={<ProtectedRoute pageKey="Roles" ><Search /> </ProtectedRoute>
                      }
                    />

                    
                    <Route
                      path="/permission"
                      element={<ProtectedRoute pageKey="Permission" ><Permission /> </ProtectedRoute>}
                    />

                    <Route
                      path="/user"
                      element={<ProtectedRoute pageKey="Users" ><Handler /> </ProtectedRoute>}
                    />
                    <Route
                      path="/add-user"
                      element={<ProtectedRoute pageKey="Users" ><AddHandler /> </ProtectedRoute>}
                    />


                    <Route
                      path="/testimonials"
                      element={<ProtectedRoute pageKey="Testimonials" > <Testimonial /></ProtectedRoute>}
                    />

                    <Route
                      path="/add-testimonials"
                      element={<ProtectedRoute pageKey="Testimonials" > <AddTestimonial /></ProtectedRoute>}
                    />

                    <Route
                      path="/news-letter"
                      element={<ProtectedRoute pageKey="newsletter" ><Newsletter /></ProtectedRoute>}
                    />

                    <Route
                      path="/settings"
                      element={
                        <ProtectedRoute pageKey="Website Settings" > <Setting /> </ProtectedRoute>}
                    />

                    <Route
                      path="/change-password"
                      element={<ProtectedRoute pageKey="Change Password" ><ChangePasssword /></ProtectedRoute>}
                    />

                    <Route
                      path="/profile"
                      element={<ProtectedRoute pageKey="Profile" ><Profile /></ProtectedRoute>}
                    />


                    <Route
                      path="/email-configuration"
                      element={<ProtectedRoute pageKey="Email Configuration" ><EmailConfiguration /></ProtectedRoute>}
                    />
                    <Route
                      path="/social-media"
                      element={<ProtectedRoute pageKey="Social Media Icons" ><SocialMedia /></ProtectedRoute>}
                    />
                    
                    <Route
                      path="/email-template"
                      element={<ProtectedRoute pageKey="Email Template" > <EmailTemplate /></ProtectedRoute>}
                    />
                    <Route
                      path="/add-email-template"
                      element={<ProtectedRoute pageKey="Email Template" > <AddEmailtemplate /> </ProtectedRoute>}
                    />

                    <Route
                      path="/sitemap"
                      element={<ProtectedRoute pageKey="Sitemap" ><Sitemap />  </ProtectedRoute>}
                    />
                    <Route
                      path="/payment-method"
                      element={<ProtectedRoute pageKey="Payment Methods" > <Payment /> </ProtectedRoute>}
                    />

                    <Route path="/add-payment-method" pageKey="Payment Methods" element={<AddPaymentMethod />} />

                    <Route
                      path="/invoice/:id"
                      element={<ProtectedRoute pageKey="Orders" > <Invoice /></ProtectedRoute>}
                    />

                    <Route
                      path="/popups"
                      element={
                        <ProtectedRoute pageKey="Popup Manager" > <Popups /> </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-popups"
                      element={<ProtectedRoute pageKey="Popup Manager" ><AddPopups /></ProtectedRoute>}
                    />


                    <Route
                      path="/collections"
                      element={<ProtectedRoute pageKey="Collection" ><Collection />  </ProtectedRoute>}
                    />
                    <Route
                      path="/page"
                      element={<ProtectedRoute pageKey="Dashboard" ><PagePermission />  </ProtectedRoute>} />


                    <Route
                      path="/add-collection"
                      element={<ProtectedRoute pageKey="Collection" > <AddCollection /></ProtectedRoute>}
                    />
                    <Route
                      path="/product-collection/:collectionId"
                      element={<ProtectedRoute pageKey="Collection" ><ProductCollection />  </ProtectedRoute>}
                    />
                    <Route
                      path="/catalogue-collection/:collectionId"
                      element={<ProtectedRoute pageKey="Collection" ><CatalogueCollection />  </ProtectedRoute>}
                    />

                    <Route
                      path="/home-section"
                      element={<ProtectedRoute pageKey="Home section" ><HomeSection />  </ProtectedRoute>}
                    />
                    <Route
                      path="/add-home-section"
                      element={<ProtectedRoute pageKey="Home Items" > <AddHomeSection /></ProtectedRoute>}
                    />
                    <Route
                      path="/home-items/:itemId"
                      element={<ProtectedRoute pageKey="Home Items" ><HomeItem />  </ProtectedRoute>}
                    />
                    {/* <Route
                    path="/catalogue-home-item/:itemId"
                    element={<ProtectedRoute pageKey="Home Item" ><CatalogueItem />  </ProtectedRoute>}
                  /> */}

                    <Route
                      path="/theme"
                      element={
                        <ProtectedRoute pageKey="theme" >
                          <Theme />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-theme"
                      element={
                        <ProtectedRoute pageKey="theme" >
                          <AddTheme />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>

                </Layout>
              </RequireAuth>
            }
          />
        </Routes>
        <ToastContainer autoClose={1000} />
      </Router>
    </PermissionProvider>
  );
}

export default App;
